import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../Model/Common/common.service';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ComboService } from '../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { AllotmentDetailService } from '../allotment-detail.service';
import { SessionService } from '../Util/Session/session.service';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { EmployeeFilterComponent } from '../employee-filter/employee-filter.component';

@Component({
  selector: 'app-allotment-delete',
  standalone: true,
  imports: [CommonModule, FormsModule, DataTablesModule, LoaderComponent],
  templateUrl: './allotment-delete.component.html',
  styleUrl: './allotment-delete.component.scss'
})
export class AllotmentDeleteComponent {

  isDisabled: boolean = false;
  TableData = [] as any;
  user = {} as any;
  dtoptions: DataTables.Settings = {};
  constructor(
    public common: CommonService,
    public comboload: ComboService,
    private toast: ToastService,
    private allotmentService: AllotmentDetailService,
    private session: SessionService,
    private modalService: NgbModal
  ) {
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {

  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  EmpCode = '';
  EmpMasterID = 0;
  EmpName = '';

  ComboLoad(Combotype: String) {
    if (this.EmpCode.trim() == '') {
      this.toast.show({ message: 'Enter Employee Code', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'UserType': 'A',
      'BranchId': 0,
      'ClientId': 0,
      'SiteId': 0,
      'EmpType': 'front',
      'EmpCode': this.EmpCode
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'EmpLoadForRegularization') {
            if (response.ComboLoad.length == 0) {
              this.EmpMasterID = 0;
              this.EmpName = '';
              this.TableData = [];
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
                this.dtTrigger.next(null);
              });
              this.toast.show({ message: 'Invalid Employee Code', type: toastTypeEnum.warning });
              this.isDisabled = false;
              return;
            }
            const data = response.ComboLoad[0];
            this.EmpMasterID = data.EmpMasterID;
            this.EmpName = data.Name;
            this.AllotmentDataLoad();
          }
        }
        // this.isDisabled = false;
      },
      complete: () => {
        // this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  AllotmentDataLoad() {
    this.isDisabled = true;
    this.allotmentService.AllotmentDeleteLoad({
      EmpMasterID: this.EmpMasterID
    }).subscribe({
      next: (response) => {
        this.TableData = response.Table;
        if (this.TableData.length == 0) {
          this.toast.show({ message: 'No data found', type: toastTypeEnum.warning });
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      }
    })
  }

  DeleteAllotment(item: any) {
    if (!item.Select) {
      this.toast.show({ message: 'Select data to delete', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true;
    this.allotmentService.AllotmentDelete({
      TransactionID: item.TransactionID,
      EmpMasterID: item.EmpMasterID,
      By: this.user.UserId,
      FromSiteId: item.FromSiteId,
      ToSiteId: item.ToSiteId
    }).subscribe({
      next: (response) => {
        if (response.Error_Message) {
          if (response.Error_Message.includes('ERROR')) {
            this.isDisabled = false;
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => { });
          } else {
            this.isDisabled = false;
            const modalRef = this.modalService.open(AlertSuccessComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = response.Error_Message;
            modalRef.result.then((result: any) => {
              if (result) {
                this.ComboLoad('EmpLoadForRegularization');
              }
            });
          }
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      }
    })
  }

  FilterEmployee() {
    const modalRef = this.modalService.open(EmployeeFilterComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg'
    })

    modalRef.result.then((result) => {
      // console.log("Modal closed with: ", result);
      this.EmpCode = result.EmpCode;
      this.EmpMasterID = result.EmpMasterID;
      this.EmpName = result.Name;
      this.ComboLoad('EmpLoadForRegularization');
    })
  }

  excelDownload() {
    if (this.TableData.length > 0) {
      this.common.ExcelDump('Allotment Preview', this.TableData);
    } else {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    }
  }

}
